import { isBrowser } from 'ws-scripts/modules/environment';

export const replaceCarouselImageWithHTML = (wrapper, item) => {
	if (!isBrowser) {
		return;
	}

	const { src, html, callback, vehicle } = item;

	const callbackIsFunc = typeof callback === 'function';

	// We need HTML or a callback specified in order to proceed.
	if (!(html || callbackIsFunc)) {
		return;
	}

	// Get the insert location
	const image = wrapper.querySelector(`img[src="${src}"]`);

	// Image has already been replaced
	if (!image) {
		return;
	}

	const parent = image.parentElement;
	const height = image.clientHeight || parent.clientHeight;
	const width = image.clientWidth || parent.clientWidth;

	// Create the HTML node to insert
	const el = document.createElement('div');
	el.setAttribute('style', `height: ${height}px;`);

	if (html) {
		el.innerHTML = html;
	}

	// Append the HTML
	parent.appendChild(el);

	// Remove the placeholder image
	image.remove();

	// Fix the blurred background image index
	const blurredBackground = parent.querySelector('.blurred-background');

	if (blurredBackground) {
		blurredBackground.style['z-index'] = -1;
	}

	parent.style['background-image'] = 'none';

	// Trigger the callback if specified
	if (callbackIsFunc) {
		callback({
			el,
			locationId: 'carousel',
			height,
			width,
			vehicle
		});
	}
};

export const replacePhotoswipeImageWithHTML = (pSwipe) => {
	const { currItem } = pSwipe;
	const { callback, html, vehicle } = currItem;

	const callbackIsFunc = typeof callback === 'function';

	// We need HTML or a callback specified in order to proceed.
	if (!(html || callbackIsFunc)) {
		return;
	}

	const el = currItem?.container?.querySelector('[data-location-id]');

	if (!el) {
		return;
	}

	if (html) {
		el.innerHTML = html;
	}

	const { viewportSize, options } = pSwipe;
	const { barsSize } = options;

	// Account for Photoswipe UI features when calculating available width and height.
	const clientWidth = viewportSize.x || el.clientWidth;
	const clientHeight = viewportSize.y || el.clientHeight;
	const heightOffset = (barsSize.top + barsSize.bottom) * 1.2;

	const calculatedHeight = clientHeight - heightOffset;

	const marginTop =
		clientHeight > clientWidth
			? (clientHeight - calculatedHeight) / 2.2
			: barsSize.top;

	el.style.top = `${marginTop}px`;

	if (callbackIsFunc) {
		callback({
			el,
			locationId: 'photoswipe',
			width: clientWidth,
			height: calculatedHeight,
			vehicle
		});
	}
};
